import { INSTALLATION_CATEGORY } from '$lib/consts'
import { boxes } from '../[region=region]/+page.svelte'
import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

const DATA = {
	WOLTAIR_CZ: {
		start: {
			buttons: [],
			components: [
				{
					this: 'FirstStep',
					attrs: {
						content: {
							heading: 'Fotovoltaická elektrárna na&nbsp;klíč do 50 dní',
							text: 'Pokud nestihneme nainstalovat fotovoltaiku do 50 pracovních dní, smluvně vám garantujeme slevu 50 %. <a href="/fotovoltaika-30-50" class="pb-4-res inline-block">Podmínky akce</a> <br /> Cenovou nabídku i s kalkulací vašich úspor získáte do 1 minuty.',
							button: 'Spustit kalkulačku',
							subtext: 'Zanechte nám číslo a my vám zavoláme.',
							icon: {
								url: '/images/icons/panel.svg',
								alternativeText: 'Ikona fotovoltaického panelu'
							}
						},
						deviceType: INSTALLATION_CATEGORY.FOTOVOLTAIKA,
						boxes,
						gotoStep: '0',
						testId: 'calculator'
					}
				}
			]
		},
		0: {
			buttons: [],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Znáte svoji roční<br>spotřebu elektřiny?'
					}
				},
				{
					this: 'Element',
					attrs: {
						margin: 'my-4',
						tag: 'p',
						color: '#666',
						content:
							'Vaše současná spotřeba elektřiny je klíčová informace pro návrh velikosti fotovoltaické elektrárny a odhad dosažitelných úspor.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						label: 'Znám svojí spotřebu',
						name: 'variant',
						value: 'a',
						del: 'floorSquare',
						gotoStep: '0.5a',
						testId: 'variant-a'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						label: 'Znám plochu domu',
						name: 'variant',
						value: 'b',
						del: 'annualyElectroConsumption',
						gotoStep: '0.3b',
						testId: 'variant-b'
					}
				}
			]
		},
		'0.3b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						gotoStep: '0.6b',
						text: 'Pokračovat',
						name: 'floorSquare',
						testId: 'floorSquare-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jaká je podlahová plocha vytápěných místností?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'mt-3',
						content:
							'Celková plocha ovlivňuje množství energie potřebné k vytápění i k provozu dalších zařízení.'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'floorSquare',
						type: 'number',
						unit: 'm2',
						testId: 'floorSquare'
					}
				}
			]
		},
		'0.6b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.3b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jakou máte míru zateplení domu?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Na základě tohoto údaje jsme schopni odhadnout tepelnou ztrátu Vaší nemovitosti.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Vysokou',
						value: 'HIGH',
						hint: 'Kompletní zateplení v posledních 10 letech',
						gotoStep: '1b',
						testId: 'isoLevel-high'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Střední',
						value: 'MEDIUM',
						hint: 'Nějaké zateplení v posledních 20 letech',
						gotoStep: '1b',
						testId: 'isoLevel-medium'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Nízkou',
						value: 'LOW',
						hint: 'Žádné zateplení v posledních 20 letech',
						gotoStep: '1b',
						testId: 'isoLevel-low'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Žádnou',
						value: 'NO',
						hint: 'Velmi stará nemovitost bez rekonstrukce',
						gotoStep: '1b',
						testId: 'isoLevel-none'
					}
				}
			]
		},
		'0.5a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						gotoStep: '1a',
						text: 'Pokračovat',
						name: 'annualyElectroConsumption',
						testId: 'annualyElectroConsumption-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Vyplňte prosím roční spotřebu elektřiny'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Vaše současná spotřeba elektřiny je klíčová informace pro návrh velikosti fotovoltaické elektrárny a odhad dosažitelných úspor.'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content: 'Běžná spotřeba rodinného domu je cca 4 — 10 MWh'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'annualyElectroConsumption',
						type: 'number',
						unit: 'MWh',
						testId: 'annualyElectroConsumption'
					}
				}
			]
		},
		'1a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.5a'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jakým způsobem<br>vytápíte dům?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Energie na vytápění typicky představuje až 70 procent energie spotřebované v domácnosti, a proto je důležité vědět, jestli se elektřinou vytápí, nebo ne.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Elektrický kotel nebo přímotopy',
						value: 'ELECTRO',
						gotoStep: '2a',
						testId: 'houseHeatType-electro'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Tepelné čerpadlo',
						value: 'HEATPUMP',
						gotoStep: '2a',
						testId: 'houseHeatType-heatpump'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Jiným způsobem',
						value: 'COAL',
						gotoStep: '2a',
						testId: 'houseHeatType-other'
					}
				}
			]
		},
		'1b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.6b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jakým způsobem<br>vytápíte dům?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Energie na vytápění typicky představuje až 70 procent energie spotřebované v domácnosti, a proto je důležité vědět, jestli se elektřinou vytápí, nebo ne.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Elektrický kotel nebo přímotopy',
						value: 'ELECTRO',
						gotoStep: '2b',
						testId: 'houseHeatType-electro'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Tepelné čerpadlo',
						value: 'HEATPUMP',
						gotoStep: '2b',
						testId: 'houseHeatType-heatpump'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Jiným způsobem',
						value: 'COAL',
						gotoStep: '2b',
						testId: 'houseHeatType-other'
					}
				}
			]
		},
		'2a': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jakým způsobem ohříváte teplou vodu?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Ohřev teplé vody představuje typicky 15–20 procent spotřeby energie, proto je nutné to zohlednit v návrhu fotovoltaické elektrárny.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Topným zdrojem',
						value: 'true',
						gotoStep: '3a',
						testId: 'waterHeating-heatingSource'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Elektrickým bojlerem',
						value: 'false',
						gotoStep: '3a',
						testId: 'waterHeating-electricBoiler'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Jiným způsobem',
						value: 'false',
						gotoStep: '3a',
						testId: 'waterHeating-other'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1a'
					}
				}
			]
		},
		'2b': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Jakým způsobem ohříváte teplou vodu?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Ohřev teplé vody představuje typicky 15–20 procent spotřeby energie, proto je nutné to zohlednit v návrhu fotovoltaické elektrárny.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Topným zdrojem',
						value: 'true',
						gotoStep: '2.5b',
						testId: 'waterHeating-heatingSource'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Elektrickým bojlerem',
						value: 'false',
						gotoStep: '2.5b',
						testId: 'waterHeating-electricBoiler'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Jiným způsobem',
						value: 'false',
						gotoStep: '2.5b',
						testId: 'waterHeating-other'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1b'
					}
				}
			]
		},
		'2.5b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Pro kolik osob chcete ohřívat teplou vodu?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Každý člověk zvyšuje spotřebu energie, je proto důležité zohlednit počet osob trvale žijících v domácnosti.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '1',
						value: '1',
						gotoStep: '3b',
						testId: 'peopleCount-1'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '2',
						value: '2',
						gotoStep: '3b',
						testId: 'peopleCount-2'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '3',
						value: '3',
						gotoStep: '3b',
						testId: 'peopleCount-3'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '4',
						value: '4',
						gotoStep: '3b',
						testId: 'peopleCount-4'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '5',
						value: '5',
						gotoStep: '3b',
						testId: 'peopleCount-5'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '6',
						value: '6',
						gotoStep: '3b',
						testId: 'peopleCount-6'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: 'Více',
						value: '7',
						gotoStep: '3b',
						testId: 'peopleCount-7'
					}
				}
			]
		},
		'3a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2a'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Máte klimatizaci, saunu nebo bazén?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Typické energeticky náročné spotřebiče v domácnosti ovlivní velikost navrhované fotovoltaické elektrárny.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ano',
						value: 'true',
						gotoStep: '4a',
						testId: 'airCondition-yes'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ne',
						value: 'false',
						gotoStep: '4a',
						testId: 'airCondition-no'
					}
				}
			]
		},
		'3b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2.5b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Máte klimatizaci, saunu nebo bazén?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Typické energeticky náročné spotřebiče v domácnosti ovlivní velikost navrhované fotovoltaické elektrárny.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ano',
						value: 'true',
						gotoStep: '4b',
						testId: 'airCondition-yes'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ne',
						value: 'false',
						gotoStep: '4b',
						testId: 'airCondition-no'
					}
				}
			]
		},
		'4a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '3a'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'zipcode',
						text: 'Pokračovat',
						gotoStep: '5a',
						testId: 'zipcode-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Zadejte PSČ instalace'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content: 'PSČ nám pomůže určit potenciální výkon fotovoltaických panelů.'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'zipcode',
						testId: 'zipcode'
					}
				}
			]
		},
		'4b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '3b'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'zipcode',
						text: 'Pokračovat',
						gotoStep: '5b',
						testId: 'zipcode-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Zadejte PSČ instalace'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content: 'PSČ nám pomůže určit potenciální výkon fotovoltaických panelů.'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'zipcode',
						testId: 'zipcode'
					}
				}
			]
		},
		'5a': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Nabídku vám okamžitě zašleme na email'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'img',
						cls: 'my-4 mx-auto',
						width: '80%',
						maxWidth: '450px',
						src: '/images/woltadvisor/PV.webp'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'email',
						label: 'Email',
						testId: 'email'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'phone',
						label: 'Telefon',
						testId: 'phone',
						hint: 'Žádné nevyžádané hovory. Číslo je v bezpečí.'
					}
				},
				{
					this: 'Affiliate',
					attrs: {
						name: 'affiliateCode',
						label: 'Zadat promo kód'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'personalMeeting',
						label: 'Mám zájem o schůzku s expertem',
						testId: 'personalMeeting',
						cls: 'justify-end items-center'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '4a'
					}
				},
				{
					this: 'Button',
					attrs: {
						type: 'submit',
						center: false,
						margin: '!my-0',
						text: 'Odeslat nabídku',
						testId: 'submit'
					}
				}
			],
			conditions: true
		},
		'5b': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Nabídku vám okamžitě zašleme na email'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'img',
						cls: 'my-4 mx-auto',
						width: '80%',
						maxWidth: '450px',
						src: '/images/woltadvisor/PV.webp'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'email',
						label: 'Email',
						testId: 'email'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'phone',
						label: 'Telefon',
						testId: 'phone',
						hint: 'Žádné nevyžádané hovory. Číslo je v bezpečí.'
					}
				},
				{
					this: 'Affiliate',
					attrs: {
						name: 'affiliateCode',
						label: 'Zadat promo kód'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'personalMeeting',
						label: 'Mám zájem o schůzku s expertem',
						testId: 'personalMeeting',
						cls: 'justify-end items-center'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '4b'
					}
				},
				{
					this: 'Button',
					attrs: {
						type: 'submit',
						center: false,
						margin: '!my-0',
						text: 'Odeslat nabídku',
						testId: 'submit'
					}
				}
			],
			conditions: true
		}
	},

	WOLTAIR_DE: {
		start: {
			buttons: [],
			components: {
				this: 'FirstStep',
				attrs: {
					content: {
						heading: 'Schlüsselfertige Photovoltaikanlage',
						text: 'Preisangebot und Berechnung Ihrer Einsparungen erhalten Sie innerhalb von 1 Minute.',
						button: 'Rechner starten',
						subtext: 'Hinterlassen Sie uns Ihre Nummer und wir rufen Sie zurück.',
						icon: {
							url: '/images/icons/panel.svg',
							alternativeText: 'Icon eines Photovoltaik-Panels'
						}
					},
					deviceType: INSTALLATION_CATEGORY.FOTOVOLTAIKA,
					boxes,
					gotoStep: '0',
					testId: 'calculator'
				}
			}
		},
		0: {
			buttons: [],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Kennen Sie Ihren jährlichen<br>Stromverbrauch?'
					}
				},
				{
					this: 'Element',
					attrs: {
						margin: 'my-4',
						tag: 'p',
						color: '#666',
						content:
							'Ihr aktueller Stromverbrauch ist eine entscheidende Information für die Planung der Größe der Photovoltaikanlage und die Abschätzung der erzielbaren Einsparungen.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						label: 'Ich kenne meinen Verbrauch',
						name: 'variant',
						value: 'a',
						del: 'floorSquare',
						gotoStep: '0.5a',
						testId: 'variant-a'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						label: 'Ich kenne die Fläche des Hauses',
						name: 'variant',
						value: 'b',
						del: 'annualyElectroConsumption',
						gotoStep: '0.3b',
						testId: 'variant-b'
					}
				}
			]
		},
		'0.3b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						gotoStep: '0.6b',
						text: 'Fortfahren',
						name: 'floorSquare',
						testId: 'floorSquare-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie groß ist die beheizte Bodenfläche der Räume?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'mt-3',
						content:
							'Die Gesamtfläche beeinflusst die Menge an Energie, die zum Heizen und zum Betrieb anderer Geräte benötigt wird.'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'floorSquare',
						type: 'number',
						unit: 'm2',
						testId: 'floorSquare'
					}
				}
			]
		},
		'0.6b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.3b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie hoch ist das Dämmniveau Ihres Hauses?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content: 'Anhand dieser Angabe können wir den Wärmeverlust Ihrer Immobilie abschätzen.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Hoch',
						value: 'HIGH',
						hint: 'Komplette Dämmung in den letzten 10 Jahren',
						gotoStep: '1b',
						testId: 'isoLevel-high'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Mittel',
						value: 'MEDIUM',
						hint: 'Einige Dämmung in den letzten 20 Jahren',
						gotoStep: '1b',
						testId: 'isoLevel-medium'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Niedrig',
						value: 'LOW',
						hint: 'Keine Dämmung in den letzten 20 Jahren',
						gotoStep: '1b',
						testId: 'isoLevel-low'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'isoLevel',
						label: 'Keine',
						value: 'NO',
						hint: 'Sehr altes Anwesen ohne Renovierung',
						gotoStep: '1b',
						testId: 'isoLevel-none'
					}
				}
			]
		},
		'0.5a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						gotoStep: '1a',
						text: 'Weiter',
						name: 'annualyElectroConsumption',
						testId: 'annualyElectroConsumption-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie hoch ist Ihr jährlicher Stromverbrauch?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'mt-3',
						content: 'Bitte geben Sie Ihren jährlichen Stromverbrauch in Kilowattstunden (kWh) ein.'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'"Der durchschnittliche Verbrauch eines Einfamilienhauses liegt bei etwa 4 bis 10 MWh'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'annualyElectroConsumption',
						type: 'number',
						unit: 'MWh',
						testId: 'annualyElectroConsumption'
					}
				}
			]
		},
		'1a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.5a'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wo befindet sich Ihr Haus?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Der Standort Ihres Hauses hat einen Einfluss auf die Sonneneinstrahlung und somit auf die Leistung der Photovoltaikanlage.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Elektrischer Kessel oder Direktheizungen',
						value: 'ELECTRO',
						gotoStep: '2a',
						testId: 'houseHeatType-electro'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Wärmepumpe',
						value: 'HEATPUMP',
						gotoStep: '2a',
						testId: 'houseHeatType-heatpump'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Auf andere Weise',
						value: 'COAL',
						gotoStep: '2a',
						testId: 'houseHeatType-other'
					}
				}
			]
		},
		'1b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.6b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie heizen Sie das Haus?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Die Energie für die Heizung macht typischerweise bis zu 70 Prozent der im Haushalt verbrauchten Energie aus, daher ist es wichtig zu wissen, ob mit Strom geheizt wird oder nicht.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Elektrische Heizung oder Direktheizer',
						value: 'ELECTRO',
						gotoStep: '2b',
						testId: 'houseHeatType-electro'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Wärmepumpe',
						value: 'HEATPUMP',
						gotoStep: '2b',
						testId: 'houseHeatType-heatpump'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'houseHeatType',
						label: 'Auf andere Weise',
						value: 'COAL',
						gotoStep: '2b',
						testId: 'houseHeatType-other'
					}
				}
			]
		},
		'2a': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie erwärmen Sie das Warmwasser?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Die Warmwasserbereitung macht typischerweise 15–20 Prozent des Energieverbrauchs aus, daher ist es wichtig, dies bei der Planung der Photovoltaikanlage zu berücksichtigen.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Mit der Heizquelle',
						value: 'true',
						gotoStep: '3a',
						testId: 'waterHeating-heatingSource'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Elektrischer Warmwasserspeicher',
						value: 'false',
						gotoStep: '3a',
						testId: 'waterHeating-electricBoiler'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Auf andere Weise',
						value: 'false',
						gotoStep: '3a',
						testId: 'waterHeating-other'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1a'
					}
				}
			]
		},
		'2b': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wie erwärmen Sie das Warmwasser?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Die Warmwasserbereitung macht typischerweise 15–20 Prozent des Energieverbrauchs aus, daher ist es wichtig, dies bei der Planung der Photovoltaikanlage zu berücksichtigen.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Mit der Heizquelle',
						value: 'true',
						gotoStep: '2.5b',
						testId: 'waterHeating-heatingSource'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Elektrischer Warmwasserspeicher',
						value: 'false',
						gotoStep: '2.5b',
						testId: 'waterHeating-electricBoiler'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'waterHeatingWithHouseHeatSource',
						label: 'Auf andere Weise',
						value: 'false',
						gotoStep: '2.5b',
						testId: 'waterHeating-other'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1b'
					}
				}
			]
		},
		'2.5b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Für wie viele Personen möchten Sie Warmwasser bereitstellen?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Jede Person erhöht den Energieverbrauch, daher ist es wichtig, die Anzahl der Personen, die ständig im Haushalt leben, zu berücksichtigen.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '1',
						value: '1',
						gotoStep: '3b',
						testId: 'peopleCount-1'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '2',
						value: '2',
						gotoStep: '3b',
						testId: 'peopleCount-2'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '3',
						value: '3',
						gotoStep: '3b',
						testId: 'peopleCount-3'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '4',
						value: '4',
						gotoStep: '3b',
						testId: 'peopleCount-4'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '5',
						value: '5',
						gotoStep: '3b',
						testId: 'peopleCount-5'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: '6',
						value: '6',
						gotoStep: '3b',
						testId: 'peopleCount-6'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'peopleCount',
						label: 'Mehr',
						value: '7',
						gotoStep: '3b',
						testId: 'peopleCount-7'
					}
				}
			]
		},
		'3a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2a'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Haben Sie eine Klimaanlage, Sauna oder Pool?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Typische energieintensive Geräte im Haushalt beeinflussen die Größe der geplanten Photovoltaikanlage.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ja',
						value: 'true',
						gotoStep: '4a',
						testId: 'airCondition-yes'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Nein',
						value: 'false',
						gotoStep: '4a',
						testId: 'airCondition-no'
					}
				}
			]
		},
		'3b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2.5b'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Haben Sie eine Klimaanlage, Sauna oder Pool?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'my-4',
						content:
							'Typische energieintensive Geräte im Haushalt beeinflussen die Größe der geplanten Photovoltaikanlage.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Ja',
						value: 'true',
						gotoStep: '4b',
						testId: 'airCondition-yes'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'airCondition',
						label: 'Nein',
						value: 'false',
						gotoStep: '4b',
						testId: 'airCondition-no'
					}
				}
			]
		},
		'4a': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '3a'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'location',
						text: 'Weiter',
						gotoStep: '5a',
						testId: 'location-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Geben Sie die Installationsadresse ein'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Die Adresse des Objekts, an dem Sie die Installation der PV-Anlage planen, ist für uns wichtig, um die Größe des Dachs und dessen Eignung für die Installation zu beurteilen, z.B. Neigung, Ausrichtung.'
					}
				},
				{
					this: 'LocationCZ',
					attrs: {
						regionName: true,
						gotoStep: '5a',
						testId: 'location'
					}
				}
			],
			conditions: 'Adresse'
		},
		'4b': {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '3b'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'location',
						text: 'Weiter',
						gotoStep: '5b',
						testId: 'location-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Geben Sie die Installationsadresse ein'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Die Adresse des Objekts, an dem Sie die Installation der PV-Anlage planen, ist für uns wichtig, um die Größe des Dachs und dessen Eignung für die Installation zu beurteilen, z.B. Neigung, Ausrichtung.'
					}
				},
				{
					this: 'LocationCZ',
					attrs: {
						regionName: true,
						gotoStep: '5b',
						testId: 'location'
					}
				}
			],
			conditions: 'Adresse'
		},
		'5a': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wir senden Ihnen unser Angebot sofort per E-Mail'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'img',
						cls: 'my-4 mx-auto',
						width: '80%',
						maxWidth: '450px',
						src: '/images/woltadvisor/PV.webp'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'email',
						label: 'E-Mail',
						testId: 'email'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'phone',
						label: 'Telefon',
						testId: 'phone',
						hint: 'Keine unerwünschten Anrufe. Ihre Nummer ist sicher.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'personalMeeting',
						label: 'Ich möchte einen Termin mit einem Experten vereinbaren',
						testId: 'personalMeeting'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '4a'
					}
				},
				{
					this: 'Button',
					attrs: {
						type: 'submit',
						center: false,
						margin: '!my-0',
						text: 'Angebot senden',
						testId: 'submit'
					}
				}
			],
			conditions: true
		},
		'5b': {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Wir senden Ihnen unser Angebot sofort per E-Mail'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'img',
						cls: 'my-4 mx-auto',
						width: '80%',
						maxWidth: '450px',
						src: '/images/woltadvisor/PV.webp'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'email',
						label: 'E-Mail',
						testId: 'email'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'phone',
						label: 'Telefon',
						testId: 'phone',
						hint: 'Keine unerwünschten Anrufe. Ihre Nummer ist sicher.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'personalMeeting',
						label: 'Ich möchte einen Termin mit einem Experten vereinbaren',
						testId: 'personalMeeting'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '4b'
					}
				},
				{
					this: 'Button',
					attrs: {
						type: 'submit',
						center: false,
						margin: '!my-0',
						text: 'Angebot senden',
						testId: 'submit'
					}
				}
			]
		}
	},
	WOLTAIR_PL: {
		start: {
			components: [
				{
					this: 'FirstStep',
					attrs: {
						content: {
							heading: 'Kalkulator cen fotowoltaiki',
							text: 'Oferta cenowa zostanie przedstawiona tutaj lub wysłana do Ciebie drogą mailową. Nasza kalkulacja jest bezpłatna i niewiążąca. Działamy na terenie całej Polski.',
							button: 'Uruchomić kalkulator',
							icon: {
								url: '/images/icons/panel.svg',
								alternativeText: 'Ikona panelu fotowoltaicznego'
							}
						},
						testId: 'calculator-fve',
						deviceType: INSTALLATION_CATEGORY.FOTOVOLTAIKA,
						gotoStep: '0'
					}
				}
			]
		},
		0: {
			buttons: [],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Czy znasz roczne zużycie energii elektrycznej w Twoim gospodarstwie domowym?'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						margin: 'my-4',
						content:
							'Twoje bieżące zużycie energii elektrycznej jest kluczową informacją dla zaprojektowania odpowiedniej wielkości instalacji fotowoltaicznej i oszacowania oszczędności, które możesz dzięki niej uzyskać.'
					}
				},
				{
					this: 'OptionButton',
					attrs: {
						text: 'Znam swoje roczne zużycie',
						gotoStep: '0.5',
						testId: 'variant-a'
					}
				},
				{
					this: 'OptionButton',
					attrs: {
						text: 'Nie znam swojego rocznego zużycia',
						href: '/fotowoltaika/kontakt',
						testId: 'variant-b'
					}
				}
			]
		},
		0.5: {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'annualyElectroConsumption',
						gotoStep: '1',
						text: 'Dalej',
						testId: 'annualyElectroConsumption-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Podaj roczne zużycie energii elektrycznej w Twoim domu'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Twoje bieżące zużycie energii elektrycznej jest kluczową informacją dla zaprojektowania odpowiedniej wielkości instalacji fotowoltaicznej i oszacowania oszczędności, które możesz dzięki niej uzyskać.'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Średnie zużycie energii elektrycznej w domu jednorodzinnym wynosi ok. 4-10 MWh.',
						margin: 'mb-4'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'annualyElectroConsumption',
						type: 'number',
						unit: 'MWh',
						testId: 'annualyElectroConsumption'
					}
				}
			]
		},
		1: {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '0.5'
					}
				},
				{
					this: 'NextStep',
					attrs: {
						name: 'location',
						text: 'Dalej',
						gotoStep: '2',
						testId: 'location-submit'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Lokalizacja instalacji'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Adres budynku, w którym zamierzasz zainstalować PV, jest dla nas ważny ze względu na ocenę wielkości dachu oraz jego konstrukcji, mającej wpływ na montaż paneli np. nachylenie, orientacja.'
					}
				},
				{
					this: 'Address',
					attrs: {
						gotoStep: '2',
						gotoStepMap: '1.5',
						testId: 'location'
					}
				}
			],
			conditions: 'address'
		},
		1.5: {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Lokalizacja instalacji'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Oznacz swój dom na mapie, abyśmy mogli określić, na której części dachu powinny zostać zamontowane moduły fotowoltaiczne.'
					}
				},
				{
					this: 'Map',
					attrs: {
						gotoStep: '2',
						testId: 'location'
					}
				}
			]
		},
		2: {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '1'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Miejsce instalacji paneli'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content: 'Dobór konkretnego systemu montażowego zależy od rodzaju dachu.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Dach skośny',
						value: 'SELECT',
						gotoStep: '2.5',
						testId: 'fveRoofType-select'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Dach płaski',
						value: 'FLAT_ROOF',
						gotoStep: '3',
						testId: 'fveRoofType-flat_roof'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Konstrukcja gruntowa',
						value: 'GROUND',
						gotoStep: '3',
						testId: 'fveRoofType-ground'
					}
				}
			]
		},
		2.5: {
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2'
					}
				}
			],
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Rodzaj pokrycia dachowego'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						color: '#666',
						content:
							'Szczegółowe informacje dotyczące pokrycia dachowego znajdującego się na Twoim dachu są niezbędne do wykonania rzetelnej wyceny.'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Dachówka betonowa/ceramiczna',
						value: 'CERAMIC_TILE',
						gotoStep: '3',
						testId: 'fveRoofType-ceramic_title'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Blacha trapezowa',
						value: 'TRAPEZOIDAL_SHEET',
						gotoStep: '3',
						testId: 'fveRoofType-trapezoidal_sheet'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Blacha na rąbek',
						value: 'SEAM_SHEET',
						gotoStep: '3',
						testId: 'fveRoofType-seam_sheet'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Blachodachówka',
						value: 'STEEL_TILE',
						gotoStep: '3',
						testId: 'fveRoofType-steel_tile'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'radio',
						name: 'fveRoofType',
						label: 'Gont bitumiczny',
						value: 'ROOF_SHINGLE',
						gotoStep: '3',
						testId: 'fveRoofType-roof_shingle'
					}
				}
			]
		},
		3: {
			components: [
				{
					this: 'Element',
					attrs: {
						tag: 'h3',
						margin: 'mt-3',
						content: 'Otrzymaj link do oferty do pobrania'
					}
				},
				{
					this: 'Element',
					attrs: {
						tag: 'p',
						margin: 'mt-3',
						content:
							'Posiadamy wszystkie informacje, dzięki którym już teraz możemy przedstawić Ci szczegółową propozycję cenową. Z racji, iż do każdej inwestycji pochodzimy indywidualnie, nasz ekspert skontaktuje się z Panem/Panią celem zebrania dodatkowych informacji oraz omówienia kalkulacji. Link do jej pobrania wyślemy na podany przez Ciebie adres e-mail.'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'email',
						label: 'E-mail',
						testId: 'email'
					}
				},
				{
					this: 'Field',
					attrs: {
						name: 'phone',
						label: 'Telefon',
						testId: 'phone'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'personalMeeting',
						label: 'Chcę umówić się na spotkanie z ekspertem',
						testId: 'personalMeeting'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'plainText',
						label:
							'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Woltair.pl sp. z o.o. dla celów zindywidualizowanego marketingu bezpośredniego i przekazywanie mi informacji handlowych przy użyciu telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących, w tym poprzez:',
						testId: 'marketingConsentHeading',
						maxWidth: '500px'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'marketingConsentEmail',
						label: 'E-mail',
						testId: 'marketingConsentEmail',
						maxWidth: '500px'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'marketingConsentPhone',
						label: 'Telefon (tj. połączenia telefoniczne lub/i SMS lub/i MMS)',
						testId: 'marketingConsentPhone',
						maxWidth: '500px'
					}
				},
				{
					this: 'Field',
					attrs: {
						type: 'checkbox',
						name: 'marketingConsentPost',
						label: 'Pocztę tradycyjną',
						testId: 'marketingConsentPost',
						maxWidth: '500px'
					}
				}
			],
			buttons: [
				{
					this: 'PrevStep',
					attrs: {
						gotoStep: '2'
					}
				},
				{
					this: 'Button',
					attrs: {
						text: 'Prześlij ofertę',
						center: false,
						margin: '!my-0',
						type: 'submit',
						testId: 'submit'
					}
				}
			],
			conditions: 'checkbox'
		}
	}
}

export default DATA[PUBLIC_WOLTAIR_WEB_CODE]
